import React from 'react';
import { Component } from '../../../dispatcher/modules';
import Container from '../container/Container';
import { 
  PUZZLE_PANEL_GROUP_PROPS, 
  PUZZLE_PANEL_GROUP_ROW_PROPS 
} from './Types';
import TextComponent from '../../UI/text_component/TextComponent';
import { isString } from 'lodash';
import classnames from 'classnames';

export default class PuzzlePanelGroup extends Component<PUZZLE_PANEL_GROUP_PROPS> {
  render() {
    const {
      data,
      leftBold = false,
      ariaLabel,
      additionalClassName = '',
      dataCy = 'panel-group',
      tableAdditionalClassName,
      borderBottom
    } = this.props;

    const tableClassName = classnames(
      tableAdditionalClassName,
      {
        'tp-border-bottom': borderBottom
      }
    ) || undefined;

    return (
      <Container
        hBox
        className={`tp-panel-group k-text-left ${additionalClassName}`}
        gap={4}
        dataCy={dataCy}
      >
        <table
          className={tableClassName}
        >
          <caption className={'sr-only'}>{ariaLabel}</caption>
          <tbody>
            {data.map((row: PUZZLE_PANEL_GROUP_ROW_PROPS, index: number) => (
              <tr key={`tableRow-${index}`}>
                <th
                  scope={'row'}
                  key={`columnHeader-${index}`}
                >
                  <TextComponent
                    thickness={leftBold ? 'medium' : undefined}
                    className={row.thCellAdditionalClassName}
                  >
                    {row.headerCellValue}
                  </TextComponent>
                </th>
                <td>
                  <TextComponent
                    htmlTag={row.htmlTag}
                    href={isString(row.cellValue) ? row.cellValue : undefined}
                    thickness={!leftBold ? 'medium' : undefined}
                    className={row.cellAdditionalClassName}
                  >
                    {row.cellValue}
                  </TextComponent>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Container>
    );
  }
}
